import { createRoot } from "react-dom/client";
import "./common/styles/main.scss";
import "react-loading-skeleton/dist/skeleton.css";
import AuthWrapper from "./app/AuthWrapper";
import { Provider } from "react-redux";
import { store } from "./app/store";
import {
    AuthProvider,
    TAuthConfig,
    TRefreshTokenExpiredEvent,
} from "react-oauth2-code-pkce";
import { setupTracing } from "./common/utils/tempoTracing";

setupTracing();

const authConfig: TAuthConfig = {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authorizationEndpoint: import.meta.env.VITE_AUTH_URL + "/oauth/authorize",
    tokenEndpoint: import.meta.env.VITE_AUTH_URL + "/oauth/token",
    redirectUri: import.meta.env.VITE_APP_URL + "/",
    logoutEndpoint: import.meta.env.VITE_AUTH_URL + "/apiV2/oauth/logout",
    loginMethod: "redirect",
    storage: "local",
    extraAuthParameters: { prompt: "login" },
    onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) =>
        window.confirm(
            "Session expired. Refresh page to continue using the site?",
        ) && event.login(),
};

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <AuthProvider authConfig={authConfig}>
        <Provider store={store}>
            <AuthWrapper />
        </Provider>
    </AuthProvider>,
);
